import { useMutation } from "@tanstack/react-query";

import { useApiClient } from "../../api";
import { PathsDictionary } from "../../api/schema/openapi";

export const useUploadDocument = () => {
  const client = useApiClient();

  const mutationFn = ({ name, file }: { name: string; file: File }) => {
    const formData = new FormData();
    formData.append("name", name);
    formData.append("file", file);

    const path: keyof PathsDictionary = "/api/v1/documents/upload";

    type Result = {
      id: string;
      message: string;
    };

    return client.api.post<Result>(path, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  };

  return useMutation({
    mutationFn,
  });
};
